export default __webpack_public_path__ + "static/media/Mic.12ab404f.svg";